import { selectBadge } from "@faire/deprecated-retailer-visitor-shared/components/ProductBadge/badgeUtils";
import { IBadge } from "@faire/web-api--source/indigofair/badges/IBadge";
import { IBadgeList } from "@faire/web-api--source/indigofair/badges/IBadgeList";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

export interface TopBadgesProps {
  showEventBadge: boolean | undefined;
  topBadge: IBadge | undefined;
  hideBadge: boolean | undefined;

  // Tracking
  productToken: string | undefined;
  badgeList: IBadgeList | undefined;
}

export const productTileTopBadgesPropsILeanProductTileAdapter = (
  productTile: ILeanProductTile
): TopBadgesProps => {
  return {
    showEventBadge: productTile.is_highlighted_product_for_promotional_event,
    topBadge: selectBadge(productTile.badge_list?.badges ?? []),
    hideBadge: !productTile.product,
    productToken: productTile.product?.token,
    badgeList: productTile.badge_list,
  };
};
